@if (isLoading()) {
  <div class="http-loading-overlay">
    <div class="spinner-container">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  </div>
}
